export const START_GET_MANAGERS = "START_GET_MANAGERS";
export const START_GET_CLIENTS = "START_GET_CLIENTS";

export const SUCCESS_GET_MANAGERS = "SUCCESS_GET_MANAGERS";
export const SUCCESS_GET_CLIENTS = "SUCCESS_GET_CLIENTS";

export const FAIL_GET_MANAGERS = "FAIL_GET_MANAGERS";
export const FAIL_GET_CLIENTS = "FAIL_GET_CLIENTS";
